import { render, staticRenderFns } from "./HeadProjectedExemp.vue?vue&type=template&id=b2329302"
import script from "./HeadProjectedExemp.vue?vue&type=script&lang=js"
export * from "./HeadProjectedExemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports